import { useMutation, useQueryClient, useQuery } from 'react-query';

import api from '@src/utils/api';
import { SSEMBLE } from '@src/constants/endpoints';
import { useVpSnackbar } from '@vp-ui';

const createSsembleRequest = async (payload) => {
  await api.post(`${SSEMBLE}`, payload);
};

export const useCreateSsembleRequest = () => {
  const { addSnackbarSuccess } = useVpSnackbar();
  const queryClient = useQueryClient();

  return useMutation(createSsembleRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries([SSEMBLE]);
      addSnackbarSuccess({
        message: `We're creating edited versions of your video. This process typically takes 10-40 minutes. You can safely exit this page.`,
        title: 'Processing',
        severity: 'info',
        autoHideDuration: 15000,
      });
    },
  });
};

const getSsembleRequests = () => {
  return api.get(`${SSEMBLE}`);
};

export const useGetSsembleRequests = () => {
  return useQuery([SSEMBLE], getSsembleRequests);
};

const fetchSsembleTemplates = async () => {
  const response = await api.get(`${SSEMBLE}/get-templates?language=en`);
  return response.templates;
};

export const useSsembleTemplatesQuery = () => {
  return useQuery('templates', fetchSsembleTemplates);
};

const fetchCountSsembleRequests = async () => {
  const response = await api.get(`${SSEMBLE}/count-cycle-requests`);
  return response.count;
};

export const useCountSsembleRequests = () => {
  return useQuery([SSEMBLE, 'count-cycle-requests'], fetchCountSsembleRequests);
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useSsemble.js